import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "_flex _gap-2 _py-2 gfu-animation-pulse",
  "data-qa": "skeleton-object"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_skeleton_image, { size: 96 }),
    _createVNode(_component_skeleton_line, {
      height: 60,
      class: "_grow-1"
    })
  ]))
}